// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2MLCB","top":"styles_top__1N0ZH","left":"styles_left__1Og5E","description":"styles_description__2ZFnl"};